"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfConfirmEmailChangeDto = instanceOfConfirmEmailChangeDto;
exports.ConfirmEmailChangeDtoFromJSON = ConfirmEmailChangeDtoFromJSON;
exports.ConfirmEmailChangeDtoFromJSONTyped = ConfirmEmailChangeDtoFromJSONTyped;
exports.ConfirmEmailChangeDtoToJSON = ConfirmEmailChangeDtoToJSON;
exports.ConfirmEmailChangeDtoToJSONTyped = ConfirmEmailChangeDtoToJSONTyped;
/**
 * Check if a given object implements the ConfirmEmailChangeDto interface.
 */
function instanceOfConfirmEmailChangeDto(value) {
    if (!('otp' in value) || value['otp'] === undefined)
        return false;
    return true;
}
function ConfirmEmailChangeDtoFromJSON(json) {
    return ConfirmEmailChangeDtoFromJSONTyped(json, false);
}
function ConfirmEmailChangeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'otp': json['otp'],
    };
}
function ConfirmEmailChangeDtoToJSON(json) {
    return ConfirmEmailChangeDtoToJSONTyped(json, false);
}
function ConfirmEmailChangeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'otp': value['otp'],
    };
}
